import { setProps, getProps } from '../props';
import { clearProject } from '../State/project';
import { setFetching } from '../State/fetching';
import fetchProject from '../Services/fetchProject';

export default (props) => (dispatch) => {
  const oldProps = getProps();
  setProps(props);
  
  // Check if the project ID has changed
  const oldProjectId = oldProps && oldProps.match && oldProps.match.params && oldProps.match.params.id;
  const newProjectId = props && props.match && props.match.params && props.match.params.id;
  
  if (oldProjectId && newProjectId && oldProjectId !== newProjectId) {
    // Clear the old project data and show loading state
    dispatch(clearProject());
    dispatch(setFetching(true));
    
    // Fetch the new project
    dispatch(fetchProject());
  }
};